import { gql } from '__generated__/gql'

export const UpdateCandidateAdditionalInfoMutation = gql(/* GraphQL */ `
    mutation UpdateCandidateAdditionalInfo(
        $staffer: StafferEntry!
        $internship: WorkExperienceEntry
        $otherAnalystsNames: [String!]
        $tierId: String
        $analystClassYear: Float
    ) {
        updateCandidateAdditionalInfo(
            staffer: $staffer
            internship: $internship
            otherAnalystsNames: $otherAnalystsNames
            tierId: $tierId
            analystClassYear: $analystClassYear
        ) {
            success
        }
    }
`)

export const UpdateCandidateWorkExperienceMutation = gql(/* GraphQL */ `
    mutation UpdateCandidateWorkExperiences(
        $userId: ID
        $workExperience: [WorkExperienceEntry!]
    ) {
        updateCandidateWorkExperiences(
            userId: $userId
            workExperience: $workExperience
        ) {
            success
            message
        }
    }
`)

export const GetCandidateWorkExperienceOptions = gql(/* GraphQL */ `
    query GetCandidateWorkExperienceOptions {
        titles {
            id
            value
        }
        industries {
            id
            value
        }
        sectors {
            id
            value
        }
    }
`)

export const GetCandidateProfileForCandidate = gql(/* GraphQL */ `
    query GetCandidateProfileForCandidate($userId: ID!) {
        candidate(userId: $userId) {
            user {
                phone
                profileImageKey
                email
                id
            }
            testScores {
                satMathScore
                satVerbalScore
                satWritingScore
                satTotal
                actScore
                gmatScore
                greTotalScore
                greVerbalScore
                greQuantitativeScore
                greWritingScore
                tookActSatTests
                remembersTakingActSatTests
            }
            id
            analystClassYear
            otherAnalysts {
                analyst
            }
            staffers {
                staffer {
                    id
                    firstName
                    lastName
                    phone
                    email
                    titleId
                }
            }
            tier {
                tier {
                    id
                    value
                }
            }
            linkedinUrl
            candidateIntakes {
                completionDate
            }
            documents {
                createdAt
                updatedAt
                id
                documentType
                documentKey
            }
            employmentType {
                id
                value
            }
            startYear
            city
            country {
                id
                value
            }
            province {
                id
                value
            }
            state {
                id
                value
            }
            gender {
                gender {
                    id
                    value
                }
            }
            ethnicities {
                ethnicity {
                    id
                    value
                }
            }
            lgbtq {
                lgbtq {
                    id
                    value
                }
            }
            visaStatuses {
                visaStatus {
                    id
                    value
                }
            }
            programs {
                id
                value
            }
            veteranStatus {
                veteranStatus {
                    id
                    value
                }
            }
            languages {
                language {
                    id
                    value
                }
            }
            education {
                id
                degrees {
                    id
                    value
                }
                degreeTypeId
                college {
                    isActive
                    id
                    value
                }
                graduationDate
                gpa
                gpaScale
                majors {
                    major {
                        value
                        id
                    }
                    majorId
                    id
                }
            }
            workExperience {
                id
                isCurrent
                company {
                    id
                    value
                }
                title {
                    id
                    value
                }
                companyOffice {
                    id
                    officeLocation {
                        id
                        value
                    }
                }
                industries {
                    industry {
                        id
                        value
                    }
                }
                sectors {
                    sector {
                        id
                        value
                    }
                }
                workEmail
                workPhone
                startDate
                endDate
                internship {
                    returnReason
                    returnRequest
                }
            }
            mostRecentInternship {
                id
                startDate
                endDate
                company {
                    id
                    value
                }
                title {
                    id
                    value
                }
                internship {
                    returnReason
                    returnRequest
                }
                companyOffice {
                    id
                    officeLocationId
                    officeLocation {
                        id
                        value
                    }
                }
                industries {
                    industry {
                        id
                        value
                    }
                }
                sectors {
                    sector {
                        id
                        value
                    }
                }
            }
            references {
                id
                firstName
                lastName
                email
                phone
                workTitleId
                company {
                    id
                    value
                }
            }
        }
    }
`)

export const GetCompaniesById = gql(/* GraphQL */ `
    query GetCompaniesById($ids: [ID!]!) {
        companiesById(ids: $ids) {
            id
            value
            companyOffices {
                id
                officeLocation {
                    id
                    value
                }
            }
        }
    }
`)
